import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let event_id = useDataValue({
    context: 'automation',
    path: 'event_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      event_id,
    },
    pause: !event_id,
    requestPolicy: 'network-only',
  }
}
